/* * @Author: Czr 
    * @Date: 2022-05-25 16:08:03 
 * @Last Modified by: Czr
 * @Last Modified time: 2022-06-09 13:30:54
    */

<template>
    <div class="roots">

        <Head></Head>
    </div>
</template>

<script>
import Head from "@/components/header.vue";
// import orgtree from "@/components/orgtree.vue";
export default {
  components: {
    Head
    // orgtree
  }
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/views/roots.vue